import React from "react";

export default ({icon: IC, name}) => (
  <>
    {IC && (
      <div className="merchant-nav-item__icon">
        <IC />
      </div>
    )}
    <div className="merchant-nav-item__text">
      {name}
    </div>
  </>
);
